import React, { useState, useCallback, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core";
import AddAPhotoOutlinedIcon from "@material-ui/icons/AddAPhotoOutlined";
import { Image } from "src/apps/commons/dataDisplays";
import useHttpErrorHandler from "src/hooks/useHttpErrorHandler";
import * as FileApi from "../api";

const useStyles = makeStyles((_: Theme) => ({
  image: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "120px",
    height: "120px",
    margin: "auto"
  }
}));

interface Props {
  label: string;
  fileId?: FileUploadId;
  className?: string;
}
interface StateProps {
  isLoading: boolean;
  file?: IFileUpload;
  imageBlob?: string;
}
const FileUploadImage = (props: Props) => {
  const { label, fileId: defaultFileId, className } = props;
  const classes = useStyles();
  const { handleError } = useHttpErrorHandler();

  const [state, setState] = useState<StateProps>({ isLoading: false });

  const fetchFile = useCallback(
    async (fileId: string) => {
      setState(s => ({ ...s, isLoading: true }));
      try {
        const infoResponse = await FileApi.info(fileId);
        const response = await FileApi.download(fileId);
        const blob = await response.blob();
        const imageBlob = URL.createObjectURL(blob);
        setState({
          isLoading: false,
          file: infoResponse.value,
          imageBlob: imageBlob
        });
      } catch (e) {
        handleError(e);
        setState({ isLoading: false });
      }
    },
    [handleError]
  );

  useEffect(() => {
    if (defaultFileId) {
      fetchFile(defaultFileId);
    } else {
      setState({ isLoading: false });
    }
  }, [defaultFileId, fetchFile]);

  return state.imageBlob ? (
    <Image
      label={label}
      imageSrc={state.imageBlob}
      fileName={state.file?.origName}
      className={className}
    />
  ) : (
    <div className={classes.image}>
      <AddAPhotoOutlinedIcon />
    </div>
  );
};

export default FileUploadImage;
